/**
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import moment from 'moment';

/**
 * Provide a momentJs abstraction service.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

function install(Vue: any, config: any = {}): void {
    const isSupported: boolean = true;

    // determine if the client supports local storage
    const name: string = 'moment';

    Vue.mixin({
        beforeCreate(): void {
            if (!isSupported) {
                return;
            }
        },
    });

    Vue[name] = moment;
    Vue.prototype[`$${name}`] = moment;
}

export default install;
